import { Directive, Output, Input, EventEmitter, HostBinding, HostListener, ElementRef, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appFilesDragDrop]'
})
export class FilesDragDropDirective {

    @Output() fileDropped = new EventEmitter<any>();

    @HostBinding('class.dragover-file')
    dragOver = false;

    dropArea: HTMLElement;

    constructor(
        protected hostEl: ElementRef,
        protected renderer: Renderer2
    ) {
    }

    @HostListener('dragenter', ['$event'])
    onDragEnter(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.dragOver = true;

        if (!this.dropArea) {
            this.dropArea = this.renderer.createElement('div');
            this.renderer.addClass(this.dropArea, 'file-drop-area');
            this.renderer.setStyle(this.dropArea, 'z-index', '10000')

            this.renderer.appendChild(this.hostEl.nativeElement, this.dropArea)

            this.renderer.listen(this.dropArea, 'dragleave', this.onDragLeave.bind(this))
            this.renderer.listen(this.dropArea, 'drop', this.onDrop.bind(this))
        }
    }


    @HostListener('dragover', ['$event'])
    onDragOver(evt) {
        evt.preventDefault();
        evt.stopPropagation();
    }

    onDragLeave(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.dragOver = false;

        this.dropArea.remove();
        this.dropArea = null;
    }

    onDrop(evt) {
        evt.preventDefault();
        evt.stopPropagation();

        this.dropArea.remove();
        this.dropArea = null;

        this.dragOver = false;

        // const files = evt.dataTransfer.files;
        // if (files.length > 0) {
        // 	this.fileDropped.emit(files)
        // }
    }
}
